import './styles/_variables.css';
import './styles/_base.css';
import './styles/show-message.css';
import { application_header } from './application_header/application_header.js';
import { application_main } from './application_main/application_main.js';
import { application_menu } from './application_menu/application_menu.js';
import { application_menu_option } from './application_menu_option/application_menu_option.js';
import { application_page } from './application_page/application_page.js';
import { input_number_field } from './input_number_field/input_number_field.js';
import { input_checkbox_field } from './input_checkbox_field/input_checkbox_field.js';
import { input_textarea_field } from './input_textarea_field/input_textarea_field.js';
import { form_action_buttons } from './form_action_buttons/form_action_buttons.js';
import { data_display } from './data_display/data_display.js';
import { layout_grid } from './layout_grid/layout_grid.js';
import { display_note } from './display_note/display_note.js';
import { display_paragraph } from './display_paragraph/display_paragraph.js';
import { display_link } from './display_link/display_link.js';
import { display_warning } from './display_warning/display_warning.js';
import { display_cta } from './display_cta/display_cta.js';
import { display_image } from './display_image/display_image.js';
import { display_collapsible } from './display_collapsible/display_collapsible.js';
import { display_table } from './display_table/display_table.js';
import { display_code } from './display_code/display_code.js';
import { application_footer } from './application_footer/application_footer.js';

if (typeof window !== 'undefined') {
  const componentes = {
    'application-header': application_header,
    'application-main': application_main,
    'application-menu': application_menu,
    'application-menu-option': application_menu_option,
    'application-page': application_page,
    'application-footer': application_footer,
    'data-display': data_display,
    'display-note': display_note,
    'display-paragraph': display_paragraph,
    'display-link': display_link,
    'display-warning': display_warning,
    'display-cta': display_cta,
    'display-image': display_image,
    'display-collapsible': display_collapsible,
    'display-table': display_table,
    'display-code': display_code,
    'layout-grid': layout_grid,
    'form-action-buttons': form_action_buttons,
    'input-checkbox-field': input_checkbox_field,
    'input-number-field': input_number_field,
    'input-textarea-field': input_textarea_field
  };

  Object.entries(componentes).forEach(([tag, classe]) => {
    if (!customElements.get(tag)) {
      customElements.define(tag, classe);
    }
  });
}

